import { ClimateShiftAddOrShowFavouritesEnum } from "@/util/cosntants";
import { AverageTemperatureHistogram, IGetLocationsResModel, TemperatureStatResponse } from "@/util/http/ClimateShift/responseType";

export const normalActionTypes = {
    NORMAL_UPDATE_LOCATION_SELECTEDLOCATIONDATA: "NORMAL_UPDATE_LOCATION_SELECTEDLOCATIONDATA",
    NORMAL_UPDATE_LOCATION_FETCHEDCHARTDATA: "NORMAL_UPDATE_LOCATION_FETCHEDCHARTDATA",
    NORMAL_UPDATE_LOCATION_SEARCHLOADING: "NORMAL_UPDATE_LOCATION_SEARCHLOADING",
    NORMAL_UPDATE_SUCCESSMESSAGE: "NORMAL_UPDATE_SUCCESSMESSAGE",
    NORMAL_UPDATE_ERRORMESSAGE: "NORMAL_UPDATE_ERRORMESSAGE",
    NORMAL_UPDATE_WARNINGMESSAGE: "NORMAL_UPDATE_WARNINGMESSAGE",
    NORMAL_UPDATE_ADDORSHOWFAVOURITESMODAL: "NORMAL_UPDATE_ADDORSHOWFAVOURITESMODAL",
    NORMAL_UPDATE_AUTHORCODE: "NORMAL_UPDATE_AUTHORCODE",
    NORMAL_UPDATE_SELECTED_FAVOURITEITEM: "NORMAL_UPDATE_SELECTED_FAVOURITEITEM",
    NORMAL_UPDATE_DOWNLOADALLLOADING: "NORMAL_UPDATE_DOWNLOADALLLOADING",
    NORMAL_UPDATE_COUNTRY: "NORMAL_UPDATE_COUNTRY",
    NORMAL_UPDATE_LOCATION_SELECTEDLOCATIONDATAFORAVERAGE: "NORMAL_UPDATE_LOCATION_SELECTEDLOCATIONDATAFORAVERAGE",
    NORMAL_UPDATE_SELECTED_FAVOURITEID: "NORMAL_UPDATE_SELECTED_FAVOURITEID",
};

// Action Types
export const updateSelectedLocationData = (location?: IGetLocationsResModel) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_LOCATION_SELECTEDLOCATIONDATA,
        payload: location
    };
};
export const updateFetchedChartData = (chartData?: TemperatureStatResponse[]) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_LOCATION_FETCHEDCHARTDATA,
        payload: chartData
    };
};
export const updateSearchLoading = (isLoading: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_LOCATION_SEARCHLOADING,
        payload: isLoading
    };
};
export const updateCommonSuccessMessage = (message?: string) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_SUCCESSMESSAGE,
        payload: message
    };
};
export const updateCommonErrorMessage = (message?: string) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ERRORMESSAGE,
        payload: message
    };
};
export const updateCommonWarnMessage = (message?: string) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_WARNINGMESSAGE,
        payload: message
    };
};
export const updateAddOrShowFavouritesModel = (type: ClimateShiftAddOrShowFavouritesEnum,
) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_ADDORSHOWFAVOURITESMODAL,
        payload: type
    };
};
export const updateAuthorCode = (type: string) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_AUTHORCODE,
        payload: type
    };
};
export const updateSelectedFavouriteItem = (selectedFavouriteItem?: object) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_SELECTED_FAVOURITEITEM,
        payload: selectedFavouriteItem
    };
};
export const updateDownloadAllLoading = (isLoading: boolean) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_DOWNLOADALLLOADING,
        payload: isLoading
    };
};
export const updateCountry = (country: string) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_COUNTRY,
        payload: country
    };
};
export const updateSelectedLocationDataForAverage = (location?: IGetLocationsResModel) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_LOCATION_SELECTEDLOCATIONDATAFORAVERAGE,
        payload: location
    };
};
export const updateSelectedFavouriteId = (id: number | null) => {
    return {
        type: normalActionTypes.NORMAL_UPDATE_SELECTED_FAVOURITEID,
        payload: id
    };
};